// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG {
  --colored-Block-Background: #f6a3a0;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG * {
  margin: 0;
  padding: 0;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG a {
  text-decoration: none;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG body,
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG html {
  overflow: hidden;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG .ColoredBarsAndFadeInText_fadeInTitleContainer__RwsQT {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG .ColoredBarsAndFadeInText_fadeInTitleContainer__RwsQT .ColoredBarsAndFadeInText_fadeInAnimationContainer__SLgYB {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG .ColoredBarsAndFadeInText_fadeInTitleContainer__RwsQT .ColoredBarsAndFadeInText_fadeInAnimationContainer__SLgYB .ColoredBarsAndFadeInText_fadeinMainTitleContainer__83cw\\+ {
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 5vh;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG .ColoredBarsAndFadeInText_fadeInTitleContainer__RwsQT .ColoredBarsAndFadeInText_fadeInAnimationContainer__SLgYB .ColoredBarsAndFadeInText_fadeinMainTitleContainer__83cw\\+ .ColoredBarsAndFadeInText_fadeInMainTitleText__xCfSQ {
  display: flex;
  position: relative;
  align-items: baseline;
  opacity: 0;
  font-size: 2.64rem;
  animation: ColoredBarsAndFadeInText_fadeIn__Qqbwu 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
  -webkit-animation: ColoredBarsAndFadeInText_fadeIn__Qqbwu 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
  -moz-animation: ColoredBarsAndFadeInText_fadeIn__Qqbwu 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
  -o-animation: ColoredBarsAndFadeInText_fadeIn__Qqbwu 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
  -ms-animation: ColoredBarsAndFadeInText_fadeIn__Qqbwu 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
  animation-delay: 1.8s;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG .ColoredBarsAndFadeInText_fadeInTitleContainer__RwsQT .ColoredBarsAndFadeInText_fadeInAnimationContainer__SLgYB .ColoredBarsAndFadeInText_fadeinMainTitleContainer__83cw\\+ .ColoredBarsAndFadeInText_coloredBlockLeftToRight__NLWLd {
  display: flex;
  position: absolute;
  width: 0;
  height: inherit;
  background: var(--colored-Block-Background);
  animation: ColoredBarsAndFadeInText_leftToRight__xJmfg 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) forwards;
  animation-delay: 0s;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG .ColoredBarsAndFadeInText_fadeInTitleContainer__RwsQT .ColoredBarsAndFadeInText_fadeInAnimationContainer__SLgYB .ColoredBarsAndFadeInText_fadeinMainTitleContainer__83cw\\+ .ColoredBarsAndFadeInText_coloredBlockRightToLeft__c-qll {
  display: flex;
  position: absolute;
  width: 0;
  height: inherit;
  background: var(--colored-Block-Background);
  animation: ColoredBarsAndFadeInText_rightToLeft__7xu2T 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) forwards;
  animation-delay: 0s;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG .ColoredBarsAndFadeInText_fadeInTitleContainer__RwsQT .ColoredBarsAndFadeInText_fadeInSubtitleContainer__67g93 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.36rem;
  animation: ColoredBarsAndFadeInText_fadeIn__Qqbwu 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
  -webkit-animation: ColoredBarsAndFadeInText_fadeIn__Qqbwu 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
  -moz-animation: ColoredBarsAndFadeInText_fadeIn__Qqbwu 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
  -o-animation: ColoredBarsAndFadeInText_fadeIn__Qqbwu 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
  -ms-animation: ColoredBarsAndFadeInText_fadeIn__Qqbwu 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) both;
  animation-delay: 1s;
}
@keyframes ColoredBarsAndFadeInText_fadeIn__Qqbwu {
  from {
    opacity: 0;
    right: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes ColoredBarsAndFadeInText_leftToRight__xJmfg {
  0% {
    width: 0;
    left: 0;
  }
  50% {
    width: 100%;
    left: 0;
  }
  100% {
    width: 0;
    left: 100%;
  }
}
@keyframes ColoredBarsAndFadeInText_rightToLeft__7xu2T {
  0% {
    width: 0;
    right: 0;
  }
  50% {
    width: 100%;
    right: 0;
  }
  100% {
    width: 0;
    right: 100%;
  }
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG .ColoredBarsAndFadeInText_darkTheme__e4PiE {
  --colored-Block-Background: #f6a3a0;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG .ColoredBarsAndFadeInText_lightTheme__-7tBq {
  --colored-Block-Background: #f6a3a0;
}
.ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG .ColoredBarsAndFadeInText_colorfulTheme__vls5m {
  --colored-Block-Background: #f6a3a0;
}`, "",{"version":3,"sources":["webpack://./src/components/ColoredBarsAndFadeInText/ColoredBarsAndFadeInText.module.scss"],"names":[],"mappings":"AAEA;EACA,mCAAA;AADA;AAGE;EACE,SAAA;EACA,UAAA;AADJ;AAIE;EACE,qBAAA;AAFJ;AAKE;;EAEE,gBAAA;AAHJ;AAME;EAKE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AARJ;AAUI;EACE,WAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AATN;AAWM;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAvBc;AActB;AAWQ;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,6FAAA;EACA,qGAAA;EAEA,kGAAA;EAEA,gGAAA;EAEA,iGAAA;EAEA,qBAAA;AAbV;AAgBQ;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,2CAAA;EACA,sGAAA;EAEA,mBAAA;AAfV;AAkBQ;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,2CAAA;EACA,sGAAA;EAEA,mBAAA;AAjBV;AAsBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,6FAAA;EACA,qGAAA;EAEA,kGAAA;EAEA,gGAAA;EACA,iGAAA;EACA,mBAAA;AAvBN;AA0BI;EACE;IACE,UAAA;IACA,QAAA;EAxBN;EA0BI;IACE,UAAA;EAxBN;AACF;AA2BI;EACE;IACE,QAAA;IACA,OAAA;EAzBN;EA2BI;IACE,WAAA;IACA,OAAA;EAzBN;EA2BI;IACE,QAAA;IACA,UAAA;EAzBN;AACF;AA4BI;EACE;IACE,QAAA;IACA,QAAA;EA1BN;EA4BI;IACE,WAAA;IACA,QAAA;EA1BN;EA4BI;IACE,QAAA;IACA,WAAA;EA1BN;AACF;AA8BE;EACE,mCAAA;AA5BJ;AA+BE;EACE,mCAAA;AA7BJ;AAgCE;EACE,mCAAA;AA9BJ","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.FadeInTextContainer {\n--colored-Block-Background: #{$globalHighlightColor};\n\n  * {\n    margin: 0;\n    padding: 0;\n  }\n\n  a {\n    text-decoration: none;\n  }\n\n  body,\n  html {\n    overflow: hidden;\n  }\n\n  .fadeInTitleContainer {\n    $mainBlockWidth: 30vw !default;\n    $mainBlockHeight: 5vh !default;\n    $fadeInTime: 2s !default;\n\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .fadeInAnimationContainer {\n      width: 100%;\n      height: auto;\n\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n\n      .fadeinMainTitleContainer {\n        width: 100%;\n        display: flex;\n        position: relative;\n        align-items: center;\n        justify-content: center;\n        height: $mainBlockHeight;\n\n        .fadeInMainTitleText {\n          display: flex;\n          position: relative;\n          align-items: baseline;\n          opacity: 0;\n          font-size: ($globalFontSize * 2.2);\n          animation: fadeIn $fadeInTime cubic-bezier(0.74, 0.06, 0.4, 0.92) both;\n          -webkit-animation: fadeIn $fadeInTime\n            cubic-bezier(0.74, 0.06, 0.4, 0.92) both;\n          -moz-animation: fadeIn $fadeInTime cubic-bezier(0.74, 0.06, 0.4, 0.92)\n            both;\n          -o-animation: fadeIn $fadeInTime cubic-bezier(0.74, 0.06, 0.4, 0.92)\n            both;\n          -ms-animation: fadeIn $fadeInTime cubic-bezier(0.74, 0.06, 0.4, 0.92)\n            both;\n          animation-delay: $fadeInTime * 0.9;\n        }\n\n        .coloredBlockLeftToRight {\n          display: flex;\n          position: absolute;\n          width: 0;\n          height: inherit;\n          background: var(--colored-Block-Background);\n          animation: leftToRight $fadeInTime cubic-bezier(0.74, 0.06, 0.4, 0.92)\n            forwards;\n          animation-delay: 0s;\n        }\n\n        .coloredBlockRightToLeft {\n          display: flex;\n          position: absolute;\n          width: 0;\n          height: inherit;\n          background: var(--colored-Block-Background);\n          animation: rightToLeft $fadeInTime cubic-bezier(0.74, 0.06, 0.4, 0.92)\n            forwards;\n          animation-delay: 0s;\n        }\n      }\n    }\n\n    .fadeInSubtitleContainer {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: ($globalFontSize * 0.3);\n\n      animation: fadeIn $fadeInTime cubic-bezier(0.74, 0.06, 0.4, 0.92) both;\n      -webkit-animation: fadeIn $fadeInTime cubic-bezier(0.74, 0.06, 0.4, 0.92)\n        both;\n      -moz-animation: fadeIn $fadeInTime cubic-bezier(0.74, 0.06, 0.4, 0.92)\n        both;\n      -o-animation: fadeIn $fadeInTime cubic-bezier(0.74, 0.06, 0.4, 0.92) both;\n      -ms-animation: fadeIn $fadeInTime cubic-bezier(0.74, 0.06, 0.4, 0.92) both;\n      animation-delay: 1s;\n    }\n\n    @keyframes fadeIn {\n      from {\n        opacity: 0;\n        right: 0;\n      }\n      to {\n        opacity: 1;\n      }\n    }\n\n    @keyframes leftToRight {\n      0% {\n        width: 0;\n        left: 0;\n      }\n      50% {\n        width: 100%;\n        left: 0;\n      }\n      100% {\n        width: 0;\n        left: 100%;\n      }\n    }\n\n    @keyframes rightToLeft {\n      0% {\n        width: 0;\n        right: 0;\n      }\n      50% {\n        width: 100%;\n        right: 0;\n      }\n      100% {\n        width: 0;\n        right: 100%;\n      }\n    }\n  }\n\n  .darkTheme {\n    --colored-Block-Background: #{$globalHighlightColor};\n  }\n\n  .lightTheme {\n    --colored-Block-Background: #{$globalHighlightColor};\n  }\n\n  .colorfulTheme {\n    --colored-Block-Background: #{$globalHighlightColor};\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FadeInTextContainer": `ColoredBarsAndFadeInText_FadeInTextContainer__nzuvG`,
	"fadeInTitleContainer": `ColoredBarsAndFadeInText_fadeInTitleContainer__RwsQT`,
	"fadeInAnimationContainer": `ColoredBarsAndFadeInText_fadeInAnimationContainer__SLgYB`,
	"fadeinMainTitleContainer": `ColoredBarsAndFadeInText_fadeinMainTitleContainer__83cw+`,
	"fadeInMainTitleText": `ColoredBarsAndFadeInText_fadeInMainTitleText__xCfSQ`,
	"fadeIn": `ColoredBarsAndFadeInText_fadeIn__Qqbwu`,
	"coloredBlockLeftToRight": `ColoredBarsAndFadeInText_coloredBlockLeftToRight__NLWLd`,
	"leftToRight": `ColoredBarsAndFadeInText_leftToRight__xJmfg`,
	"coloredBlockRightToLeft": `ColoredBarsAndFadeInText_coloredBlockRightToLeft__c-qll`,
	"rightToLeft": `ColoredBarsAndFadeInText_rightToLeft__7xu2T`,
	"fadeInSubtitleContainer": `ColoredBarsAndFadeInText_fadeInSubtitleContainer__67g93`,
	"darkTheme": `ColoredBarsAndFadeInText_darkTheme__e4PiE`,
	"lightTheme": `ColoredBarsAndFadeInText_lightTheme__-7tBq`,
	"colorfulTheme": `ColoredBarsAndFadeInText_colorfulTheme__vls5m`
};
export default ___CSS_LOADER_EXPORT___;
